import type { Location } from "react-router";

export const ROUTE_CHANGED = "ROUTE_CHANGED" as const;

export interface RouteChangedPayload {
  from: Location;
  to: Location;
  location: Location;
}

export const routeChanged = (from: Location, to: Location) => ({
  type: ROUTE_CHANGED,
  payload: {
    from,
    to,
    location: to
  }
});
